import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import TenantActions from '@Actions/tenantActions';
import ShopifyIntegrationActions from '@Actions/integrations/shopifyIntegrationActions';
import {
  Table, Select, notification, Popconfirm,
} from 'antd';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import {
  DeleteOutlined, PlusCircleFilled,
} from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import PRZSelect from '../../../../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const ShopifyMapLocations = ({
  user, getTenants, getTenantsLoading, tenants, getShopifyConnections, shopifyConnections, connectTenantToShopifyLocation, connectTenantToShopifyLocationLoading, setStep, getShopifyConnectionsLoading, history,
}) => {
  const [tenantData, setTenantData] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [formSubmitted, setFormSubmitted] = useState('');

  useEffect(() => {
    getTenants(1, '', true, user?.tenant_info?.org_id);
    getShopifyConnections(user?.tenant_info?.org_id);
  }, []);

  useEffect(() => {
    const copyTenantData = tenants?.data?.filter((item) => item?.shopify_location_id)?.map((tenant) => ({ ...tenant, shopify_location_id: tenant?.shopify_location_id, key: uuidv4() }));
    setTenantData(copyTenantData);
  }, [tenants]);

  const updateTableValue = (key, value, label) => {
    const data = tenantData.map((tenant) => {
      if (tenant.key === key) {
        // eslint-disable-next-line no-param-reassign
        tenant[label] = value;
        return tenant;
      }
      return tenant;
    });
    setTenantData(data);
  };

  const getSelectedTenant = (record) => tenantData?.filter((item) => !item?.is_deleted).filter((item) => item?.tenant_id !== record?.tenant_id).map((tenant) => tenant.tenant_id);

  const getSelectedLocationId = (record) => (tenantData?.length ? tenantData?.filter((item) => !item?.is_deleted)?.filter((item) => Number(item?.shopify_location_id) !== Number(record?.shopify_location_id))?.map((tenant) => Number(tenant.shopify_location_id)) : []);

  const shopName = shopifyConnections?.find((connection) => connection?.is_connected)?.shop_name;

  const getDataSource = (data) => (data ? JSON.parse(JSON.stringify(data?.filter((tenant) => !tenant.is_deleted))) : []);

  const addNewRow = () => {
    if (tenantData?.length) {
      setTenantData([...tenantData, { key: uuidv4() }]);
    } else {
      setTenantData([{}]);
    }
  };

  const removeRow = (key) => {
    if (tenantData?.filter((tenant) => !tenant.is_deleted)?.length === 1) {
      const newTenantData = tenantData?.map((tenant) => {
        if (tenant?.key === key) {
          return { ...tenant, is_deleted: true };
        }

        return { ...tenant };
      });
      setTenantData([...newTenantData, { key: uuidv4() }]);
    } else {
      const newTenantData = tenantData?.map((tenant) => {
        if (tenant?.key === key) {
          return { ...tenant, is_deleted: true };
        }

        return { ...tenant };
      });

      setTenantData(newTenantData);
    }
  };

  const columns = [
    {
      title: 'Business Unit Name',
      width: '312px',
      render: (record) => (
        <div>
          <PRZSelect
            value={record?.tenant_id}
            showSearch
            filterOption={false}
            onChange={(value) => {
              const orgId = tenants?.[0]?.org_id;
              updateTableValue(record?.key, value, 'tenant_id');
              updateTableValue(record?.key, orgId, 'org_id');
              setSearchKeyword('');
            }}
            placeholder="Select Business Unit"
            style={{
              border: !(formSubmitted && !record?.tenant_id) ? '1px solid rgba(68, 130, 218, 0.2)' : '1px solid red',
              marginRight: '10px',
            }}
            onSearch={(value) => {
              setSearchKeyword(value);
            }}
            disabled={connectTenantToShopifyLocationLoading}
          >
            {tenants?.data
              ?.filter((item) => !getSelectedTenant(record)?.includes(item?.tenant_id))
              ?.filter((item) => (searchKeyword ? item?.tenant_name?.toUpperCase()?.includes(searchKeyword?.toUpperCase()) : true))
              .map(
                (item) => <Option key={item?.tenant_id} value={item?.tenant_id}>{item?.tenant_name}</Option>,
              )}
          </PRZSelect>
        </div>
      ),
    },
    {
      title: 'Location',
      width: '275px',
      render: (record) => (
        <div>
          <PRZSelect
            value={record.shopify_location_id ? Number(record.shopify_location_id) : ''}
            filterOption={false}
            onChange={(value) => {
              updateTableValue(record?.key, value, 'shopify_location_id');
            }}
            placeholder="Select a location"
            dropdownAlign={{ offset: [-6, 4] }}
            style={{
              border: !(formSubmitted && !record?.shopify_location_id) ? '1px solid rgba(68, 130, 218, 0.2)' : '1px solid red',
              marginRight: '10px',
            }}
            disabled={connectTenantToShopifyLocationLoading}
          >
            {shopifyConnections
            && shopifyConnections
              ?.filter((connection) => connection?.is_connected)?.[0]?.locations
              ?.filter((item) => !getSelectedLocationId(record)?.includes(item?.id))
              .map((item) => (
                <Option key={item.id} value={item.id}>
                  {`${item?.name }`}
                </Option>
              ))}
          </PRZSelect>
        </div>
      ),
    },
    {
      title: '',
      render: (record) => (
        <div>
          {!record?.shopify_facility_codes?.length ? (
            <div style={{ display: 'flex', alignItems: 'baseline' }}>
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to delete this line?"
                onConfirm={() => removeRow(record?.key)}
                okText="Yes"
                cancelText="No"
              >
                <div className="deleteButton">
                  {' '}
                  <DeleteOutlined />
                  {' '}
                </div>
              </Popconfirm>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'baseline' }}>
              {' '}
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to delete this line?"
                onConfirm={() => removeRow(record?.key)}
                okText="Yes"
                cancelText="No"
              >
                <div className="deleteButton">
                  {' '}
                  <DeleteOutlined />
                  {' '}
                </div>
              </Popconfirm>

            </div>

          ) }

        </div>
      ),

    },
  ];

  const isDataValid = (data) => {
    const copyData = data?.filter((item) => !item?.is_deleted);
    for (let i = 0; i < copyData?.length; i++) {
      if (!copyData[i]?.tenant_id || !copyData[i]?.shopify_location_id) {
        return false;
      }
    }
    return true;
  };

  const handleSubmit = () => {
    setFormSubmitted(true);
    if (isDataValid(tenantData) && tenantData?.filter((item) => !item?.is_deleted && item?.tenant_id && item?.shopify_location_id).length > 0) {
      const payload = {
        org_id: user?.tenant_info?.org_id,
        shop_name: shopName,
      };
      const tenantIntegrations = tenantData?.filter((t) => t?.tenant_id)?.map((tenant) => (
        {
          tenant_id: tenant.tenant_id,
          shopify_location_id: tenant?.is_deleted ? null : tenant.shopify_location_id,
        }
      ));

      payload.tenant_integrations = tenantIntegrations;

      connectTenantToShopifyLocation(payload, () => {
        setStep(2);
      });
    } else {
      notification.error({
        message: 'Please select location for every tenant',
        placement: 'top',
        duration: 4,
      });
    }
  };

  return (
    <Fragment>
      {(getTenantsLoading || getShopifyConnectionsLoading)
        ? (
          <div className="shopify-integration__loader__wrapper">

            { [...Array(5).keys()].map((item) => (
              <div key={item} className="shopify-integration__loader-row">
                <div className="loadingBlock  shopify-integration__loader__line1" />
                <div className="loadingBlock  shopify-integration__loader__line2" />
                <div className="loadingBlock  shopify-integration__loader__line3" />
              </div>
            ))}
            <div className="loadingBlock shopify-integration__loader__line-btn1" />
            <div className="loadingBlock shopify-integration__loader__line-btn2" />
          </div>
        )
        : (
          <div className="shopify__location-wrapper">
            <div className="shopify__location-header-wrapper">
              <div className="shopify__location-header">Locations Mapping from Shopify to Procuzy</div>
              <div className="shopify__location-header-info">Please select a corresponding Procuzy location against each Shopify location. This creates a link between both platforms to enable syncing of orders and stock levels going forward.</div>
            </div>
            {/* <div className="shopify__table-pre-header">Choose a Procuzy location for your Shopify orders:</div> */}
            <div className="ant-row">
              <div className="ant-col-md-18">
                <Table
                  columns={columns}
                  loading={getTenantsLoading || getShopifyConnectionsLoading || connectTenantToShopifyLocationLoading}
                  dataSource={getDataSource(tenantData) || []}
                  size="small"
                  pagination={false}
                />
              </div>
            </div>
            <div
              className="new-row-button"
              style={{ marginLeft: '10px', marginBottom: '10px' }}
              onClick={() => {
                if (!getTenantsLoading && !getShopifyConnectionsLoading && !connectTenantToShopifyLocationLoading) {
                  addNewRow();
                }
              }}
            >
              <span className="new-row-button__icon"><PlusCircleFilled /></span>
              <div>New Item</div>
            </div>
            <div className="ant-row">
            &nbsp;&nbsp;
              <H3Button
                text="Back"
                buttonType={defaultButtonTypes.BLUE_BORDERED}
                onClick={() => history.push('/admin/integration/shopify')}
                customClass="shopify__location-submit"
                disabled={connectTenantToShopifyLocationLoading}
              />
              &nbsp;&nbsp;
              <H3Button
                text="Next Step"
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                onClick={() => handleSubmit()}
                customClass="shopify__location-submit"
                isLoading={connectTenantToShopifyLocationLoading}
                disabled={connectTenantToShopifyLocationLoading}
              />
            </div>
          </div>
        )}
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, TenantReducers, ShopifyIntegrationReducers }) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  shopifyConnections: ShopifyIntegrationReducers.shopifyConnections,
  connectTenantToShopifyLocationLoading: ShopifyIntegrationReducers.connectTenantToShopifyLocationLoading,
  getTenantsLoading: TenantReducers.getTenantsLoading,
});
const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
  getShopifyConnections: (orgId, callback) => dispatch(ShopifyIntegrationActions.getShopifyConnections(orgId, callback)),
  connectTenantToShopifyLocation: (payload, callback) => dispatch(ShopifyIntegrationActions.connectTenantToShopifyLocation(payload, callback)),
});

ShopifyMapLocations.propTypes = {
  user: PropTypes.any,
  getTenants: PropTypes.func,
  getShopifyConnectionsLoading: PropTypes.bool,
  getTenantsLoading: PropTypes.bool,
  tenants: PropTypes.any,
  getShopifyConnections: PropTypes.func,
  connectTenantToShopifyLocation: PropTypes.func,
  connectTenantToShopifyLocationLoading: PropTypes.bool,
  shopifyConnections: PropTypes.any,
  setStep: PropTypes.func,
  history: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShopifyMapLocations));
